export default [
    {
        path: 'assinatura-eletronica',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-assinatura-eletronica' */
            '@/views/pronto-atendimento/assinatura-eletronica/Index'
        ),
        redirect: 'assinatura-eletronica/index',
        children: [
            {
                name: 'pronto-atendimento-assinatura-eletronica-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-assinatura-eletronica' */
                    '@/views/pronto-atendimento/assinatura-eletronica/List'
                ),
            },
        ]
    }
]